import { isUnionPayAppChannel, isDouyinAppChannel } from './code';

/**
 * 是否可以使用 云闪付小程序 全局常量
 */
export const canIUseUnionPaySDK = isUnionPayAppChannel() && typeof upsdk !== 'undefined';
/**
 * 是否可以使用 抖音小程序 全局常量
 */
export const canIUseTiktokSDK = isDouyinAppChannel() && typeof tt !== 'undefined';
